import Vue from 'vue'
// 引入基础框架
import App from 'bjxy-component/app/index.vue'
// 初始化基础的路由
import baseRouter from 'bjxy-common/baseRouter'
// 初始化基础的Store
import baseStore from 'bjxy-common/baseStore'
// 基础网络操作
import ajax from 'bjxy-common/network'
// Vue 基础方法扩展
import vuePlugin from 'bjxy-common/vuePlugin'
// 页面路由
import pageRouter from './router'
// 页面数据仓库
import pageStore from './store'
// 页面数据上报
import reporter from 'bjxy-component/reporter'
import getQueryString from 'bjxy-common/helper/getQueryString'
// 页面数据上报2
import Xreport from 'bjxy-common/xreport'
// js/css reset
import 'bjxy-common/helper/jsReset'
import 'bjxy-common/base.css'
import 'bjxy-common'
import '@/component/utils/fundebug'
// 以下是业务引入
const store = baseStore(pageStore)
ajax(store)
const router = pageRouter(store)
baseRouter(router, store)
const x = new Xreport(router)
x.cache({
  extendEvent: { landId: getQueryString('landId') }
}, true)
Vue.mixin({
  methods: {
    xreport() {
      return x.xreport(...arguments)
    },
    pageShow() {
      return x.pageShow(...arguments)
    }
  }
})
Vue.use(vuePlugin, {store: store})
// import VConsole from 'vconsole'
// new VConsole();

/**
 * 根据业务决定 vue 初始化条件,需要 jsBridge，使用如下方式，如果不需要jsBridge，请删除jsBridge的引入
 * 如果要在vue实例化前使用post方法直接引入 network/http
 * import {post,get,} from 'bjxy-common/network/http';
 **/
const report = reporter();

new Vue({
  el: '#app',
  router,
  store,
  render(createElement) {
    return createElement(App)
  },
  methods: {
    report: report,
    reportInit: report.init
  }
})

